var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrownicon = function SvgCrownicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.624 7.219a1 1 0 0 0-1.623.822l.019.155 2 10A1 1 0 0 0 5 19h14a1 1 0 0 0 .98-.804l2-10a1 1 0 0 0-1.605-.977l-4.148 3.32-3.395-5.094a1 1 0 0 0-1.589-.099l-.075.099-3.396 5.093z"
  })));
};
export default SvgCrownicon;